import { render, staticRenderFns } from "./DragAndDropImage.vue?vue&type=template&id=19b1ca84&scoped=true"
import script from "./DragAndDropImage.vue?vue&type=script&lang=js"
export * from "./DragAndDropImage.vue?vue&type=script&lang=js"
import style0 from "./DragAndDropImage.vue?vue&type=style&index=0&id=19b1ca84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b1ca84",
  null
  
)

export default component.exports